import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8.7143 4-.0072.0071-4.7 4.7L4 8.7143v6.5714l.0071.0072 4.7 4.7.0072.0071h6.5714l.0072-.0071 4.7-4.7.0071-.0072V8.7143l-.0071-.0072-4.7-4.7L15.2857 4zm-.808-1.8388C8.1664 2.0456 8.4334 2 8.7 2h6.6c.2667 0 .5336.0456.7936.1612.2557.1136.4545.2727.6135.4317l4.7 4.7c.159.159.3181.3578.4317.6135.1156.26.1612.527.1612.7936v6.6c0 .2667-.0456.5336-.1612.7936-.1136.2557-.2727.4545-.4317.6135l-4.7 4.7c-.159.159-.3578.3181-.6135.4317-.26.1156-.5269.1612-.7936.1612H8.7c-.2667 0-.5336-.0456-.7936-.1612-.2557-.1136-.4545-.2727-.6135-.4317l-4.7-4.7c-.159-.159-.318-.3578-.4317-.6135C2.0456 15.8336 2 15.5667 2 15.3V8.7c0-.2667.0456-.5336.1612-.7936.1136-.2557.2727-.4545.4317-.6135l4.7-4.7c.159-.159.3578-.318.6135-.4317",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 7c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1V8c0-.5523.4477-1 1-1m-1 9c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1",
        clipRule: "evenodd"
    }, "1")
], "AlertOctagon", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
